import React from 'react'
import styled from 'styled-components'

const ButtonContainer = styled.div.attrs({ className: 'col'})`
  text-align: center;
  margin-bottom: 8px;
`

const LinkedinButton = ({ children, triggerLogin,  url='#linkedin', ...props }) => (
  <ButtonContainer>
      <a href={url} cursor="pointer" onClick={triggerLogin} {...props}>
          <img src="./linkedin_button.png" alt="Linkedin Login"/>
      </a>
  </ButtonContainer>
)

export default LinkedinButton


// WEBPACK FOOTER //
// ./src/components/linkedin-button.js